export default __webpack_public_path__ + "static/media/cost.331e3472.svg";